<template>
  <div class="main dl_gray_color_bg">
    <mt-header title="我的合约" class="dl_header_white dl_line_bottom" fixed>
      <mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>

      <mt-button
        slot="right"
        @click="$router.push('/token/create')"
        style="color: #1296db; font-weight: bold;"
      >创建合约</mt-button>
    </mt-header>
    <div class="content">
      <div class="item-wrap">
        <div class="card-wrap">
          <div class="card-title">
            <img src="img_url" />
            <span>HMC Pro</span>
          </div>
          <div class="token-property">
            <div>Token名称：fdafa</div>
            <div>Token符号：Hfdsadfa</div>
            <div>发行总量：Hfdsadfa</div>
            <div>发行总量：Hfdsadfa</div>
            <div>小数位数: 10</div>
          </div>
        </div>
        <div class="order-wrap">
          <div class="order-status">完成</div>
          <div class="cell-group">
            <div class="cell-label">交易hash</div>
            <div
              class="cell-value"
              @click="copy($event,shareCode)"
            >0x2f1c5c2b44f771e942a8506148e256f94f1a464babc938ae0690c6e34cd79190</div>
          </div>
          <div class="cell-group">
            <div class="cell-label">合约</div>
            <div
              class="cell-value"
              @click="copy($event,shareCode)"
            >0xdAC17F958D2ee523a2206206994597C13D831ec7</div>
          </div>
        </div>
        <div class="order-wrap">
          <div class="order-status pending">处理中</div>
        </div>
        <div class="order-wrap">
          <div class="order-status">交易失败</div>
          <div class="reason">资产余额不足</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import { httpGetTokenOrderList } from '@/api/token'
import handleClipboard from '@/utils/clipboard'
export default {
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.loadOrderList()
  },
  methods: {
    loadOrderList() {
      httpGetTokenOrderList().then(({ code, data }) => {
        if (code === 1) {
          this.list = data.list
        }
      })
    },
    copy(event, val) {
      handleClipboard(
        val,
        event,
        () => {
          Toast(this.$t('fuzhicg'))
        },
        () => {
          Toast(this.$t('fuzhicc'))
        }
      )
    },
  },
}
</script>

<style scoped>
.main {
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;
}
.content {
  padding: 10px;
}
.item-wrap {
  background-color: white;
  padding: 10px;
  border-radius: 6px;
}
.card-wrap {
  padding: 10px;
}

.token-property {
  padding: 4px;
  font-size: 14px;
}
.order-wrap {
  border-top: 1px solid #eee;
  padding: 4px 10px;
}
.order-status {
  padding: 4px 0;
  font-size: 14px;
}
.order-status.pending {
  color: red;
}
.cell-group {
  padding: 4px 0;
}
.cell-label {
  font-size: 14px;
}
.cell-value {
  margin-top: 6px;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reason {
  font-size: 14px;
}
</style>